import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  jobs: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  },
};

const reportJobsSlice = createSlice({
  name: "reportJobs",
  initialState,
  reducers: {
    fetchReportJobs: (state) => {
      state.loading = true;
      state.error = null;
      state.jobs=null;
    },
    fetchReportJobsSuccess: (state, action) => {
      state.loading = false;
      state.jobs = action.payload.jobs;
      state.pagination = action.payload.pagination;
    },
    fetchReportJobsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearReportJobs: (state) => {
      state.jobs = [];
      state.error = null;
      state.pagination = initialState.pagination;
    },
  },
});

export const { actions, reducer } = reportJobsSlice;
export const sliceKey = reportJobsSlice.name;